import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {useSearchQcRulesQuery, useLazyExportQcRuleDataQuery} from "../qcRuleApi";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../../components/common/datatable/DataTableUtils";
import {SearchInputWrapper} from "../../../../components/common/datatable/filter/SearchInputWrapper";
import {SearchSelectWithList} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import {getBooleanDisplayIcon} from "../../../../helpers/utils/Utils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {
    useLazyGetCustomerByTenantAndLevelQuery
} from "../../../customer/customerApi";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import {getEnumDisplayNameByConstant} from "../../../../helpers/utils/EnumUtils";
import {useGetAllTenantsQuery} from "../../../sysAdmin/tenant/tenantApi";
import {skipToken} from "@reduxjs/toolkit/query";
import IconButton from "../../../../components/common/form/IconButton";
import {FaPlus} from "react-icons/fa6";
import {useNavigate} from "react-router-dom";
import {useGetCodesListQuery} from "../../../sysAdmin/code/codeApi";
import {useUtilDataQuery} from "../../../profile/profileApi";

const QcLogic = () => {
    const {data: enums} = useGetEnumsQuery("");
    const navigate = useNavigate()
    const storageData = useSelector((state: any) => state.utilDataReducer);
    const [triggerExportQcRuleDataQuery] = useLazyExportQcRuleDataQuery();
    const codeListApi = useGetCodesListQuery("");
    const {data: utilData} = useUtilDataQuery("");
    const [getCustomerByTenantAndLevelApi, getCustomerByTenantAndLevelApiResponse] = useLazyGetCustomerByTenantAndLevelQuery()
    const tenantQueryApi = useGetAllTenantsQuery(
        utilData?.customerLevel === 'SYS' ? undefined : skipToken
    );

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "QC Logics", url: ""}]
    )

    useEffect(() => {
        document.title = 'QC Logics';
    }, [])

    useEffect(() => {
        if (storageData?.items) {
            let isSysLevel = storageData?.items?.customerLevel === 'SYS';
            let tenant = isSysLevel ? "" : storageData?.items?.tenant;

            if (tenant) {
                getCustomerByTenantAndLevelApi({tenantName: tenant, level: "CUSTOMER"});
            }
        }

    }, [storageData]);


    const {data: userSettings} = useFindUserSettingsByGroupNameQuery("QC Logic");
    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            cell: (props: any) => {
                let path = "/qc-logics/" + props.row.original.id;
                return createClickableLink(path, props.row.original.name, userSettings, false, "", ["LOGIC-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."} name={"name"}
                                                     accessor={"name"}/>,
            }]
        },

        {
            label: "Product Type", accessor: "productTypes",
            canSort: false,
            cell: (props: any) => {
                let content = props.row.original.productTypes?.map((cur: any) => {
                    return getEnumDisplayNameByConstant(enums?.["ProductType"], cur);
                }).join(", ");

                return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
            },

        },
        {
            label: "Code Name", accessor: "code.name",
            filterOptions: [{
                filterComponent: SearchSelectWithList(codeListApi?.data, "name", "id", "Select Code Name", false, "code"),
                overrideFilterLabel: "Code Name",
                overrideFilterAccessor: "code",
            }]
        },
        {
            label: "Tenant", accessor: "tenant",
            filterOptions: [{
                dependentColumns: ["Customer"],
                filterComponent: SearchSelectWithList(tenantQueryApi?.data, "name", "name", "Select Tenant...", false, "tenant"),
            }]
        },
        {
            label: "Customer", accessor: "customer.customerName", canSort: false,
            filterOptions: [{
                filterComponent: SearchSelectWithList(getCustomerByTenantAndLevelApiResponse?.data, "customerName", "id", "Select Customer...", false, "customerId"),
                overrideFilterLabel: "Customer",
                overrideFilterAccessor: "customerId",
                onDependencyUpdated: (value: any) => {
                    getCustomerByTenantAndLevelApi({tenantName: value, level: "CUSTOMER"});
                },
            }]
        },
        {
            label: "Enabled", accessor: "enabled",
            cell: (props: any) => getBooleanDisplayIcon(props.row.original.enabled, "Enabled", "Disabled"),
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Status...", "enabled", "Enabled", "Disabled"),
                overrideFilterLabel: "Enabled",
            }]
        },
    ]
    return (
        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs}/>
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchQcRulesQuery,
                    exportAction: triggerExportQcRuleDataQuery
                }}
                userSettingGroup={"QC Logic"}
                buttonOptions={{
                    addButton:
                        {
                            button: <IconButton
                                icon={<FaPlus/>}
                                hasBackground={true}
                                onClick={() => {
                                    navigate("/qc-logics/create")
                                }}
                                title={"Add Qc Logic"}
                            />,
                            permissions: ["LOGIC-C"]
                        },

                }}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                basePermission={"LOGIC"}
            />

        </div>

    );
};
export default QcLogic;
